import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { media } from 'context';
import { Button, Layout, Modal, Text } from 'ds';
import { PANTRY_SUBSCRIPTION_PATH } from 'routes/paths';

interface ConsumablesOnboardingChangesNotSavedModalProps {
  onClose: () => void;
  isVisible: boolean;
}

const ConsumablesOnboardingChangesNotSavedModal: React.FC<ConsumablesOnboardingChangesNotSavedModalProps> = ({
  onClose,
  isVisible
}) => {
  const history = useHistory();
  const { isMobile } = useContext(media);
  const footer = (
    <Layout flex direction="row" gap={12} width="100%" justify="flex-end" paddingBottom={8}>
      <Button size="sm" type="secondaryOutline" text="Cancel" onClick={onClose} />
      <Button size="sm" type="primary" text="Confirm" onClick={() => history.push(PANTRY_SUBSCRIPTION_PATH)} />
    </Layout>
  );
  return (
    <Modal
      onClose={onClose}
      isVisible={isVisible}
      width={500}
      footer={footer}
      header="Changes not saved"
      headerAlign="left"
      isBottomSheet={isMobile}
      bottomSheetIsRounded={isMobile}
      bottomSheetGutterTop={isMobile ? 100 : undefined}
    >
      <Layout paddingX={isMobile ? 24 : undefined}>
        <Text size="body-sm" color="gray-700">
          Leave without adding items to cart? Changes will not be saved.
        </Text>
      </Layout>
    </Modal>
  );
};

export default ConsumablesOnboardingChangesNotSavedModal;
